// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--AalMQ","text":"a10a3f92e9--text--eLbCY"};